import React from 'react';
import { bool, func, object, string } from 'prop-types';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import EquipmentTypeSelect from './EquipmentTypeSelect';
import MultiSensorSelect from './MultiSensorSelect';
import SensorTypeSelect from './SensorTypeSelect';

import defaultClasses from './ModifyRuleSensorModal.module.css';

const EquipmentSourceFieldset = ({
    errors,
    hidden,
    onBlur,
    onChange,
    onPatch,
    touched,
    ruleTarget,
    values
}) => {
    if (hidden) {
        return null;
    }

    return (
        <FormControl
            aria-labelledby="equipment-sensor-label"
            className={defaultClasses.fieldset}
            role="group"
        >
            <FormLabel
                className={defaultClasses.legend}
                id="equipment-sensor-label"
                focused={false}
            >
                Equipment Sensor Options
            </FormLabel>
            <EquipmentTypeSelect
                errors={errors}
                onBlur={onBlur}
                onPatch={onPatch}
                values={values}
                touched={touched}
            />
            <SensorTypeSelect
                errors={errors}
                onBlur={onBlur}
                onPatch={onPatch}
                values={values}
                touched={touched}
            />
            <MultiSensorSelect
                errors={errors}
                onBlur={onBlur}
                onChange={onChange}
                values={values}
                ruleTarget={ruleTarget}
                touched={touched}
            />
        </FormControl>
    );
};

EquipmentSourceFieldset.propTypes = {
    errors:   {},
    hidden:   false,
    onBlur:   () => {},
    onChange: () => {},
    onPatch:  () => {},
    touched:  {},
    values:   {}
};

EquipmentSourceFieldset.propTypes = {
    errors:     object,
    hidden:     bool,
    onBlur:     func,
    onChange:   func,
    onPatch:    func,
    ruleTarget: string,
    touched:    object,
    values:     object
};

export default EquipmentSourceFieldset;
